<template>
  <footer
    class="bg-[linear-gradient(102.34deg,#290C3D_-21.2%,#4A0776_119.49%)] text-white relative z-10"
  >
    <div class="max-w-screen-xl px-4 mx-auto py-10">
      <NuxtLink to="/" class="flex items-center text-3xl mb-10">
        <video autoplay loop muted playsinline width="50" height="39">
          <source src="/images/WRI-logo2.webm" type="video/webm" />
        </video>
        <span class="text-white"
          ><span class="border-l pl-2 border-[#B88ABE50] mt-1 font-semibold"
            >web</span
          >reinvent</span
        >
      </NuxtLink>
      <div class="flex flex-col lg:flex-row justify-between gap-6 sm:gap-20">
        <!-- Column 0: Address -->
        <div>
          <h3 class="font-semibold text-xl mb-4">Address</h3>

          <div class="flex items-start mb-6">
            <NuxtImg
              src="/images/usa.webp"
              alt="US Flag"
              height="40"
              width="40"
              class="mr-4 shrink-0"
              loading="lazy"
              format="webp"
            />
            <p class="text-lg lg:max-w-[330px]">
              7858, 1021 E Lincolnway, Cheyenne, WY, Laramie, US, 82001
            </p>
          </div>

          <div class="flex items-start">
            <NuxtImg
              src="/images/india.webp"
              alt="India Flag"
              height="40"
              width="40"
              class="mr-4 shrink-0"
              loading="lazy"
              format="webp"
            />
            <p class="text-lg lg:max-w-[340px]">
              2nd Floor, Plot 6, Apex Square 3, Pocket B 3, Sector 17, Dwarka,
              Delhi, India 110075
            </p>
          </div>

          <div class="mt-9">
            <div class="grid md:grid-cols-2 lg:grid-cols-1 gap-6 text-xl">
              <!-- Contacts -->
              <div>
                <h3 class="font-semibold mb-4 text-xl">Contacts</h3>
                <ul class="space-y-2">
                  <li class="flex items-center">
                    <span>USA: </span>
                    <a
                      href="tel:+14420328793567"
                      class="ml-1 hover:text-purple-300"
                      >+1 44 20 3287 9357</a
                    >
                  </li>
                  <li class="flex items-center">
                    <span>India: </span>
                    <a
                      href="tel:+91502287005"
                      class="ml-1 hover:text-purple-300"
                      >+1 (502) 287-0005</a
                    >
                  </li>
                  <li class="flex items-center">
                    <a
                      href="mailto:we@webreinvent.com"
                      class="hover:text-purple-300"
                      >we@webreinvent.com</a
                    >
                  </li>
                </ul>
              </div>

              <!-- Social Links -->
              <div>
                <h3 class="font-semibold text-xl mb-4">Social Links</h3>
                <div class="flex space-x-2">
                  <a
                    href="https://facebook.com/webreinvent"
                    class="bg-[#330650] border border-[#6F2D9B] rounded-md size-12 grid place-content-center"
                    aria-label="Facebook"
                  >
                    <WrFacebook size="30" />
                  </a>
                  <a
                    href="https://instagram.com/webreinvent"
                    class="bg-[#330650] border border-[#6F2D9B] rounded-md size-12 grid place-content-center"
                    aria-label="Instagram"
                  >
                    <WrInsta size="30" />
                  </a>
                  <a
                    href="https://linkedin.com/company/webreinvent"
                    class="bg-[#330650] border border-[#6F2D9B] rounded-md size-12 grid place-content-center"
                    aria-label="LinkedIn"
                  >
                    <WrLinkedIn size="30" />
                  </a>
                  <a
                    href="https://twitter.com/webreinvent"
                    class="bg-[#330650] border border-[#6F2D9B] rounded-md size-12 grid place-content-center"
                    aria-label="Twitter/X"
                  >
                    <WrTwitter size="30" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Main Footer Content -->
        <div
          class="grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-20 max-md:text-sm"
        >
          <!-- Column 1: Company -->
          <div>
            <h3 class="font-semibold text-xl mb-4">Company</h3>
            <ul class="space-y-4">
              <li>
                <NuxtLink to="/" class="hover:text-purple-300">Home</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/about-us" class="hover:text-purple-300"
                  >About</NuxtLink
                >
              </li>

              <li>
                <NuxtLink to="/services" class="hover:text-purple-300"
                  >Services</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/solutions" class="hover:text-purple-300"
                  >Solutions</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/products" class="hover:text-purple-300"
                  >Products</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/career" class="hover:text-purple-300"
                  >Career</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/capabilities" class="hover:text-purple-300"
                  >Capabilities</NuxtLink
                >
              </li>

              <li>
                <NuxtLink to="/dedicated-team" class="hover:text-purple-300"
                  >Dedicated Team</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/staff-augmentation" class="hover:text-purple-300"
                  >Staff Augmentation</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/testimonials" class="hover:text-purple-300"
                  >Testimonials</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/how-we-work" class="hover:text-purple-300"
                  >How We Work</NuxtLink
                >
              </li>
              <li>
                <NuxtLink to="/contact-us" class="hover:text-purple-300"
                  >Contact Us</NuxtLink
                >
              </li>
            </ul>
          </div>

          <!-- Column 2: Services -->
          <div>
            <h3 class="font-semibold text-xl mb-4">Services</h3>
            <div class="mb-6">
              <ul class="space-y-4 min-w-max">
                <li>
                  <NuxtLink
                    to="/services/development-services"
                    class="hover:text-purple-300"
                    >Development Services</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/languages"
                    class="hover:text-purple-300"
                    >Technologies/Language</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/frameworks"
                    class="hover:text-purple-300"
                    >Frameworks</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/cms-development"
                    class="hover:text-purple-300"
                    >CMS Development</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/mobility"
                    class="hover:text-purple-300"
                    >Mobile Apps
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink to="/services/desktop" class="hover:text-purple-300"
                    >Desktop</NuxtLink
                  >
                </li>

                <li>
                  <NuxtLink to="/services/ai" class="hover:text-purple-300"
                    >Artificial Intelligence (AI)</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/industries"
                    class="hover:text-purple-300"
                    >Industries</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink
                    to="/services/maintenance-services"
                    class="hover:text-purple-300"
                    >Maintenance Services</NuxtLink
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Column 3: Our Products -->

          <div class="max-md:col-start-1 max-md:col-end-3">
            <div>
              <h3 class="font-semibold text-xl mb-4">Our Products</h3>
              <!-- 1st Column -->
              <div class="max-md:grid max-md:grid-cols-2 max-md:gap-20">
                <div class="mb-6">
                  <h4 class="font-semibold text-lg mb-4">Open source:</h4>
                  <ul class="space-y-5 mb-10">
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/cms"
                        class="hover:text-purple-300"
                        >vaah<strong>cms</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/saas"
                        class="hover:text-purple-300"
                        >vaah<strong>saas</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/store"
                        class="hover:text-purple-300"
                        >vaah<strong>store</strong>
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/flutter"
                        class="hover:text-purple-300"
                        >vaah<strong>flutter</strong>
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/nuxt"
                        class="hover:text-purple-300"
                        >vaah<strong>nuxt</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/cli"
                        class="hover:text-purple-300"
                        >vaah<strong>cli</strong></NuxtLink
                      >
                    </li>
                  </ul>
                </div>
                <div class="mb-6">
                  <h4 class="font-semibold text-lg mb-4">Enterprise:</h4>
                  <ul class="space-y-5">
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/crm"
                        class="hover:text-purple-300"
                        >vaah<strong>crm</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/leads"
                        class="hover:text-purple-300"
                        >vaah<strong>leads</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/inbox"
                        class="hover:text-purple-300"
                        >vaah<strong>inbox</strong></NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://vaah.dev/hrm"
                        class="hover:text-purple-300"
                        >vaah<strong>hrm</strong></NuxtLink
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contacts and Social Links Section -->

      <!-- Copyright and Policies -->
    </div>
    <div
      class="py-6 px-4 bg-[linear-gradient(287.24deg,#1F0432_2.25%,#1D0231_93.17%)]"
    >
      <div
        class="max-w-[1265px] mx-auto flex flex-col md:flex-row justify-between items-center text-sm"
      >
        <div class="mb-4 md:mb-0">
          <div class="flex items-center">
            <p>
              &copy; 2010 - 2025
              <NuxtLink class="hover:text-purple-300" to="/"
                >WebReinvent Technologies Pvt Ltd.
              </NuxtLink>
            </p>
          </div>
        </div>
        <div class="flex flex-wrap justify-center gap-4">
          <NuxtLink to="/privacy-policy" class="hover:text-purple-300"
            >Privacy policy</NuxtLink
          >
          <NuxtLink to="/terms-and-conditions" class="hover:text-purple-300"
            >Terms & conditions</NuxtLink
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import WrFacebook from "../atoms/icons/WrFacebook.vue";
import WrInsta from "../atoms/icons/WrInsta.vue";
import WrLinkedIn from "../atoms/icons/WrLinkedIn.vue";
import WrTwitter from "../atoms/icons/WrTwitter.vue";
</script>
